<template>
  <app-modal>
    <el-card class="box-card">
      <el-form
        @submit.native.prevent="saveImage"
        ref="form"
        label-position="top"
        id="image"
        v-if="show"
      >
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
              <el-input v-model="image.title"></el-input>
              <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="Descripción">
              <el-input v-model="image.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Imagen">
              <app-cropper :options="options"></app-cropper>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <button v-if="this.showBottons" type="submit" class="el-button el-button--primary">
              <span>{{btn}}</span>
            </button>
            <el-button @click="closeModal()">Cerrar</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </app-modal>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper";
import Modal from "@/components/Dashboard/Modals/modal";

export default {
  name: "addImage",
  props: ["content", "imageId"],
  components: {
    "app-modal": Modal,
    "app-cropper": Cropper
  },
  created() {
    this.imageId ? this.getImage() : (this.show = true);

    this.$root.$on("imagenCargada", file => {
      this.image.url = file;
      this.showBottons = true;
    });
    this.$root.$on("imagenEliminada", () => (this.image.url = false));
  },
  data() {
    return {
      btn: "Añadir",
      image: {
        title: "",
        description: "",
        url: null
      },
      options: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 450,
        autoCropWidth: 820,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [820, 450]
      },
      errorTitle: false,
      showBottons: false,
      imageOld: null,
      show: false,
      api_uploads: API_UPLOADS
    };
  },
  methods: {
    closeModal() {
      this.$root.$emit("closeModal");
    },
    async getImage() {
      this.btn = "Editar";
      const response = await ApiService.post("dashboard/table", {
        table: "imagen",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.imageId
      });
      if (response) {
        this.image = {
          title: response.data.title,
          description: response.data.description,
          url: response.data.url
        };
        this.options.img = this.api_uploads + response.data.url;
        this.show = true;
        this.showBottons = true;
      }
    },
    async saveImage() {
      if (this.image.url.size) {
        let data = new FormData();
        data.append("file", this.image.url);

        const response = await ApiService.post("upload/galeries", data);
        if (response) this.image.url = response.data;
      }
      this.imageId > 0 ? this.update() : this.insert();
    },
    async insert() {
      ApiService.post("dashboard/editform", {
        table: "imagen",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.image
      }).then(response => {
        if (response.data != "Algo ha fallado") {
          ApiService.post("dashboard/editform", {
            table: "galeria_imagen",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            form: {
              galeria_id: this.content,
              imagen_id: response.data
            }
          }).then(response => {
            if (response.data != "Algo ha fallado") {
              this.$message({
                type: "success",
                message: "Se ha actualizado el registro"
              });
            } else {
              this.$message({
                type: "warning",
                message: "Algo ha fallado"
              });
            }
          });
        }
      });
    },
    async update() {
      ApiService.post("dashboard/editform", {
        table: "imagen",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.image,
        id: this.imageId
      }).then(response => {
        if (response.data != "Algo ha fallado") {
          this.$message({
            type: "success",
            message: "Se ha actualizado el registro"
          });
        } else {
          this.$message({
            type: "warning",
            message: "Algo ha fallado"
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/addImage.vue